export const setDeletedGuide = data => ({
  type: 'SET_DELETED_GUIDE',
  data,
});
